import BaseBrandCollection from "collections/brands";
import BrandPickerModel from "./model";

export default BaseBrandCollection.extend({
    url: "/api/v3.0/brands/list",
    model: BrandPickerModel,
});
